<template>
    <div>
        <compWrapper
            :title="
                $t('fbb.expresspackage.baseinfo', { defaultValue: '基本信息' })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="this.type == 'query'"
                :formdata="getBase"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
            <compFormEdit
                v-else
                ref="relation"
                class="margin-top-15 clearfix"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="235"
            />
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.b2c.parcel_information', { defaultValue: '包裹信息' })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="this.type == 'query'"
                :formdata="getPackage"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getPackage"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.fedex.basecost_detail', {
                    defaultValue: '基础费用明细',
                })
            "
            theme="primary"
        >
            <compFormQuery
                :formdata="getBaseCost"
                :value="formData"
                :labelWidth="235"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.fedex.extracost_detail', { defaultValue: '附加费明细' })
            "
            theme="primary"
        >
            <compTablelist
                class="margin-layout"
                :columns="columnsList"
                v-bind="getExtraDetail"
            ></compTablelist>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
        >
            <compLog
                class="margin-15"
                :data="opLogList"
                :columns="getLogcolumns"
            ></compLog>
        </compWrapper>
        <div class="text-right">
            <vButton
                class="width-15per margin-left-10"
                v-if="type != 'query'"
                @click="submit"
                theme="primary"
                >{{
                    this.$t("global.common.save", { defaultValue: "保存" })
                }}</vButton
            >
            <vButton class="width-15per margin-left-10" @click="cancel">{{
                this.$t("global.common.return", { defaultValue: "返回" })
            }}</vButton>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import {
    HttpBillImportDetailOne,
    HttpImportItem,
    HttpGetLog,
    HttpUpdateDetail,
} from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from "../fedexcost/mixin";

export default {
    mixins: [mixin],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compTablelist: () => import("@components/templates/tablelist"),
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            query: false,
            opLogList: [],
            detailList: [],
            formData: {
                // remark:'',
            },
        };
    },
    created() {
        // console.log(this.$route.params.type)
        this.query = this.type === "query";
        this.getDetail();
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierServiceList",
            "getCarrierManageList",
            "getCarrierServiceAllList",
        ]),
        getExtraDetail() {
            return {
                initFormData: {
                    "search[EQ_billDealParentId]": this.id,
                },
                startUp: true,
                ajaxRequest: HttpImportItem,
            };
        },
        getBase() {
            return [
                {
                    label: "Tracking NO",
                    key: "trackingNo",
                    query: true,
                },
                {
                    label: this.$t("erp.b2border.invoice", {
                        defaultValue: "发票号",
                    }),
                    key: "invoiceNo",
                    query: true,
                },
                {
                    label: this.$t("erp.product_channel.type", {
                        defaultValue: "类型",
                    }),
                    query: true,
                    valueText:
                        this.formData.billType == "addCost"
                            ? this.$t("fbb.fedex.extracost", {
                                  defaultValue: "附加费",
                              })
                            : this.$t("fbb.fedex.othercost", {
                                  defaultValue: "未识别",
                              }),
                },
                {
                    label: this.$t("fbb.alloment.carrier_code", {
                        defaultValue: "物流产品",
                    }),
                    // label: "物流产品",
                    key: "groupId",
                    tag: "vSelect",
                    options: this.getCarrierManageList.map((item) => {
                        return {
                            value: item.value,
                            label: item.label,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'}),
                    label: this.$t("fbb.bill.service_code", {
                        defaultValue: "承运商服务",
                    }),
                    key: "carrierServiceId",
                    tag: "vSelect",
                    options: this.getCarrierServiceAllList.map((item) => {
                        return {
                            value: item.value,
                            label: item.label,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "Net Charge Amount",
                    // key: "discountCost",
                    valueText: this.formData.discountCost + " USD",
                    query: true,
                },
                {
                    label: this.$t("fbb.fedex.zonecode", {
                        defaultValue: "分区",
                    }),
                    key: "zoneCode",
                },
                {
                    label: this.$t("fbb.alloment.taskNo", {
                        defaultValue: "任务编号",
                    }),
                    key: "taskNo",
                    query: true,
                },
            ];
        },
        getPackage() {
            return [
                {
                    label: "Dim Length(inch)",
                    key: "packageLength",
                    // valueText:this.formData.packageLength + " inch"
                },
                {
                    label: "Dim Width(inch)",
                    key: "packageWidth",
                    // valueText:this.formData.packageWidth + " inch"
                },
                {
                    label: "Dim Height(inch)",
                    key: "packageHeight",
                    // valueText:this.formData.packageHeight + " inch"
                },
                {
                    label: "Actual Weight Amount(lbs)",
                    key: "packageWeight",
                    // valueText:this.formData.packageWeight + " lbs"
                },
                {
                    label: "Rated Weight Amount(lbs)",
                    key: "ratedWeight",
                    // valueText:this.formData.ratedWeight + " lbs"
                },
            ];
        },
        getBaseCost() {
            return [
                {
                    label: "Transportation Charge Amount",
                    // key: "totalCost",
                    valueText: this.formData.totalCost + " USD",
                },
                {
                    label: "Grace Discount",
                    // key: "graceDiscount",
                    valueText: this.formData.graceDiscount + " USD",
                },
                {
                    label: "Performance Pricing",
                    // key: "performancePricing",
                    valueText: this.formData.performancePricing + " USD",
                },
                {
                    label: "Earned Discount",
                    // key: "earnedDiscount",
                    valueText: this.formData.earnedDiscount + " USD",
                },
            ];
        },
        columnsList() {
            return [
                {
                    title: this.$t("fbb.fedex.extracost_name", {
                        defaultValue: "附加费名称",
                    }),
                    key: "costName",
                },
                {
                    title: this.$t("fbb.adjustment.list_cost", {
                        defaultValue: "收费金额",
                    }),
                    key: "cost",
                },
                {
                    title: this.$t("erp.product_channel.currency", {
                        defaultValue: "币种",
                    }),
                    key: "currency",
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            if (this.type === "add") return;
            this.loading = true;
            HttpBillImportDetailOne({
                id: this.id,
            }).then(
                (res) => {
                    this.handleResponse(res.data);
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );

            if (this.query) {
                // 请求日志的接口
                HttpGetLog({
                    id: this.id,
                    module: 31,
                }).then(
                    (res) => {
                        this.opLogList = res.data;
                    },
                    (err) => {}
                );
            }
        },
        handleResponse(data = {}) {
            this.formData = data;
        },
        cancel() {
            this.$router.push({ name: "fedexBillimportdetail" });
        },
        submit() {
            HttpUpdateDetail({
                id: this.formData.id,
                groupId: this.formData.groupId,
                carrierServiceId: this.formData.carrierServiceId,
                zoneCode: this.formData.zoneCode,
                packageLength: this.formData.packageLength,
                packageWidth: this.formData.packageWidth,
                packageHeight: this.formData.packageHeight,
                packageWeight: this.formData.packageWeight,
                ratedWeight: this.formData.ratedWeight,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>
